<div class="email-wrapper dialog-wrapper">
  <button class="close-button" (click)="closePanel()">
    <mat-icon>close</mat-icon>
  </button>
  <form #emailsForm="ngForm" (ngSubmit)="sendEmails()">
    <custom-input
      [(ngModel)]="form.subject"
      [name]="'subject'"
      [required]="true"
      [type]="'string'"
      [label]="'Subject'"
      class="row"
    />
    <custom-select
      [(ngModel)]="form.emailType"
      [name]="'emailType'"
      [required]="true"
      [label]="'Email type'"
      [options]="emailTypeOptions"
      class="row"
    />
    <div class="select-options row">
      <input
        type="file"
        name="recipients"
        accept=".csv"
        (change)="onFileSelected($event)"
        style="display: none"
        id="recipients"
      />
      <button class="secondary-button" (click)="selectCSV()" type="button">
        CSV
      </button>
      <custom-checkbox
        [name]="'All hotels'"
        [label]="'All hotels'"
        (userInput)="toggleAllHotels($event)"
        [(ngModel)]="allHotels"
      />
      <custom-checkbox
        [name]="'Paid hotels'"
        [label]="'Paid hotels'"
        [(ngModel)]="paidHotels"
        (userInput)="togglePaidHotels($event)"
      />
      <custom-checkbox
        [name]="'Free hotels'"
        [label]="'Free hotels'"
        [(ngModel)]="freeHotels"
        (userInput)="toggleFreeHotels($event)"
      />
      <button
        class="delete-secondary-button"
        (click)="clearRecipients()"
        type="button"
      >
        Clear
      </button>
    </div>
    <div class="selected row">
      @for(recipient of csv; track recipient) {
      <div class="recipient">
        @for(field of recipient; track field) {
        <div>
          <span>{{field}}</span>
        </div>

        }
      </div>
      } @for(hotelData of selectedHotels; track hotelData) {
      <div class="recipient">
        @for(data of hotelData; track data) {
        <div>
          <span>{{data}}</span>
        </div>

        }
      </div>
      }
    </div>

    <button
      class="secondary-button"
      type="submit"
      id="submit"
      [disabled]="emailsForm.invalid"
    >
      Send emails
    </button>
  </form>
</div>
